export default __webpack_public_path__ + "static/media/book_8.02b5783d.svg";